export default __webpack_public_path__ + "static/partners-cbbcdeac0a0acb8cebde08f29a296e22.png";